import { BlockOverrides } from 'baseui/block';
import { THEME } from '@lyon/utils/theme';
import { InputOverrides } from 'baseui/input';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      width: '100%',
      marginTop: '32px',
      marginBottom: '24px',
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gridColumnGap: '16px',
      alignItems: 'center',

      [THEME.media.large]: {
        width: '50%',
      },
    },
  },
};

export const INPUT: InputOverrides = {
  Input: {
    style: {
      color: THEME.colors.mono600,
    },
  },
};
